import { render, staticRenderFns } from "./AudienceList.vue?vue&type=template&id=41040e8e&scoped=true"
import script from "./AudienceList.vue?vue&type=script&lang=js"
export * from "./AudienceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41040e8e",
  null
  
)

export default component.exports